import { PageHeader, PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import React from 'react';
import landingPageHeaderImage from '../../../../../assets/documentHeaderIllustration.svg';
import { useDocumentLibraryTranslations } from '../../../../../hooks';
import { DocumentLibraryContext } from '../../../../../providers';
import { FolderHeaderContent } from './FolderHeaderContent';
export const DocumentPanelHeader = ({ activeTabId, onManagePermissions, hideRootHeader }) => {
    const { t } = useDocumentLibraryTranslations();
    const { currentDirectoryId } = React.useContext(DocumentLibraryContext);
    const isArchived = activeTabId === 'archived';
    if (hideRootHeader && !currentDirectoryId) {
        return React.createElement(React.Fragment, null);
    }
    if (!currentDirectoryId) {
        return React.createElement(PageHeaderWithImage, { image: landingPageHeaderImage, gradient: 'red-base', title: t('documentPanel.title') });
    }
    return (React.createElement(PageHeader, { gradient: isArchived ? 'black-dark-linear' : 'red-base' },
        React.createElement(FolderHeaderContent, { onManagePermissions: onManagePermissions, activeTabId: activeTabId })));
};
